module.exports = __webpack_public_path__ + "img/snakeicon.cd9096d5.png";